import React from 'react';
import { styled } from '@linaria/react';
import { HorizontalScroll } from '@vio/atlas/helpers/HorizontalScroll';
import { SkeletonLoader } from '@vio/atlas/SkeletonLoader';
const _exp = /*#__PURE__*/() => SkeletonLoader;
const AvailabilityTileSkeleton = /*#__PURE__*/styled(_exp())({
  name: "AvailabilityTileSkeleton",
  class: "a1vlu8wp",
  propsAsIs: true
});
const _exp3 = /*#__PURE__*/() => HorizontalScroll;
const ScrollElement = /*#__PURE__*/styled(_exp3())({
  name: "ScrollElement",
  class: "su89kdc",
  propsAsIs: true
});
export const Loading = () => {
  return <>
      <SkeletonLoader height={20} width={180} marginTop={0} marginBottom={0} />
      <SkeletonLoader height={17} width={190} marginTop={4} marginBottom={8} />
      <ScrollElement rowGap="s300" columnGap="s300">
        <AvailabilityTileSkeleton height={78} marginTop={0} />
        <AvailabilityTileSkeleton height={78} marginTop={0} />
        <AvailabilityTileSkeleton height={78} marginTop={0} />
        <AvailabilityTileSkeleton height={78} marginTop={0} />
        <AvailabilityTileSkeleton height={78} marginTop={0} />
        <AvailabilityTileSkeleton height={78} marginTop={0} />
      </ScrollElement>
    </>;
};

require("./Loading.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Loading.tsx");